import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { IngestionEntry } from "./constants";
import { getIngestionDateLabel } from "./utils";

const IngestionInfoTable = ({ data }: { data: IngestionEntry[] }) => {
  const { t } = useTranslation("common");
  const headerClasses =
    "text-xs !font-normal text-left px-2.5 py-2 border-b border-r border-gray-100";

  const cellClasses = "p-2.5 py-3";

  return (
    <div className="border border-gray-100 rounded-lg overflow-hidden !mt-4">
      <table className="text-sm w-full border-collapse">
        <thead className="bg-slate-50">
          <tr>
            <th className={headerClasses}>{t("ingestion.data_column")}</th>
            <th className={classNames(headerClasses, "border-r-0")}>
              {t("ingestion.last_received")}
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map(({ entityType, ingestedAt, noEntryReason }, index) => (
            <tr key={index}>
              <td
                className={classNames(cellClasses, "border-r border-gray-100", {
                  "border-b border-gray-100": index < data.length - 1,
                })}
              >
                {entityType}
              </td>
              <td
                className={classNames(cellClasses, {
                  "border-b border-gray-100": index < data.length - 1,
                })}
              >
                {ingestedAt && (
                  <>
                    <span className="font-bold">
                      {getIngestionDateLabel(ingestedAt.dateLabel, t)}
                    </span>
                    <span>
                      {" "}
                      {t("ingestion.at_time", { time: ingestedAt.timeLabel })}
                    </span>
                  </>
                )}
                {!ingestedAt && <span>{noEntryReason}</span>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default IngestionInfoTable;
